// extracted by mini-css-extract-plugin
module.exports = {"text":"_561a4c86"};